const Images = {
  logo_white: "/images/logo_white.png",
  logo_colored: "/images/logo_colored.png",
  logo_small: "/images/logo_small.png",
  trip_carousel_one: "/images/trip_carousel_one.png",
  trip_carousel_two: "/images/trip_carousel_two.png",
  trip_carousel_three: "/images/trip_carousel_three.png",
  trip_carousel_four: "/images/trip_carousel_four.png",
  phone: "/images/phone.png",
  logo_navbar: "/images/logo_navbar.png",
  hero_shield: "/images/hero_shield.png",
  phone_cta: "/images/phone_cta.png",
  daily_commuter: "/images/daily_commuter.png",
  okada: "/images/okada.png",
  intercity_travel: "/images/intercity_travel.png",
  taxi: "/images/taxi.png",
  insurance_company_one: "/images/insurance_company_one.png",
  insurance_company_two: "/images/insurance_company_two.png",
  about_hero: "/images/about_hero.webp",
  contact_cta: "/images/contact_us.png",
  sunu: "/images/sunu.png",

  general_insurance: "/images/general_insurance.png",
  health_insurance_card: "/images/health_insurance_card.png",
  life_insurance: "/images/life_insurance.png",
  road_trip_card: "/images/road_trip_card.png",
  safety_card: "/images/safety_card.png",
  tourism_card: "/images/tourism_card.png",
  travel_card: "/images/travel_card.png",
  insurance_card: "/images/insurance_card.png",

  at_card: "/images/at_cash.png",
  telecel_cash: "/images/telecel_cash.png",
  mtn_momo: "/images/mtn_momo.png",

  // web
  hero_img_web_one: "/images/hero_web/hero_img_web_one.png",
  hero_img_web_two: "/images/hero_web/hero_img_web_two.png",
  hero_img_web_three: "/images/hero_web/hero_img_web_three.png",
  hero_img_web_four: "/images/hero_web/hero_img_web_four.png",
  hero_img_web_five: "/images/hero_web/hero_img_web_five.png",

  // mobile
  hero_mobile_one: "/images/hero_mobile/hero_mobile_one.png",
  hero_mobile_two: "/images/hero_mobile/hero_mobile_two.png",
  hero_mobile_three: "/images/hero_mobile/hero_mobile_three.png",
  hero_mobile_four: "/images/hero_mobile/hero_mobile_four.png",
  hero_mobile_five: "/images/hero_mobile/hero_mobile_five.png",

  // Phone Mock up
  phone_mock_up_one: "/images/phone_mock_up_one.svg",
  travel_insurance: "/images/travel_insurance.png",

  // Media and Events Images
  media_events_hero_one: "/images/media_and_events/media_events_hero_one.png",
  media_events_two: "/images/media_and_events/media_events_two.jpg",
  events_illustrator: "/images/media_and_events/events_illustrator.jpg",
  tour_packages_illustrator: "/images/media_and_events/tour_packages_illustrator.jpg",
  conference_illustrator: "/images/media_and_events/conference_illustrator.jpg",
  transparent_tracking: "/images/media_and_events/transparent_tracking.jpg",
  professional_support: "/images/media_and_events/professional_support.jpg",
  travel_protection: "/images/media_and_events/travel_protection.jpg",
  event_discovery: "/images/media_and_events/event_discovery.jpg",
  trade_mission:"/images/media_and_events/trade_mission.jpg",

  ts_shield: "/images/ts_shield.png",
};
export default Images;
